import { ModalContent, ModalWrapper } from "src/components/dca/GenericModal";
import { ModalHeader } from "../dca/GenericModal";
import { IconButton, MenuItem, Stack } from "@mui/material";
import { ArrowBackIos, Close } from "@mui/icons-material";
import {
  setStakeModalOpen,
  setStakeStage,
  setTwoFAModalOpen,
  useStakingState,
} from "src/store/features/staking.slice";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { Typography } from "@mui/material";
import {
  EndAdormentStyledLabel,
  EthereumPlaceholderLogo,
  FieldMinStakeButton,
  SmallSpanRoobertMediumDark,
  StyledStakedspan,
} from "./staking-styled-components";
import { InfoContentStyle } from "./staking-styled-components";
import { StyledSelectbuyorsellspan } from "./staking-styled-components";
import { StyledTextField } from "src/components/application/styled-components/AddressFields";
import StyledButton from "../dashboard/StyledButton";
import { Field, Form, Formik } from "formik";
import { mockCoins } from "./mock";
import { GridCheckCircleIcon } from "@mui/x-data-grid";

export const StakeModal = () => {
  const { stakeModalOpen } = useStakingState();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const { stakeStage } = useStakingState();

  return (
    <ModalWrapper open={stakeModalOpen} onClose={() => dispatch(setStakeModalOpen(false))}>
      <ModalHeader>
        {/* If mobile back button */}
        {isMobile && (
          <IconButton
            onClick={() => {
              // If stage is info, close modal
              if (stakeStage === "info") {
                dispatch(setStakeModalOpen(false));
              }
              // If stage is stake, go back to info
              if (stakeStage === "stake") {
                dispatch(setStakeStage("info"));
              }
              // If stage is review, go back to stake
              if (stakeStage === "review") {
                dispatch(setStakeStage("stake"));
              }
            }}
            sx={{ color: "white", position: "absolute", left: "16px" }}>
            <ArrowBackIos />
          </IconButton>
        )}
        <Typography fontSize={"23px"} color={"white"} fontWeight={600}>
          Stake
        </Typography>
        {/* Close Button */}
        <IconButton
          onClick={() => dispatch(setStakeModalOpen(false))}
          sx={{ color: "white", position: "absolute", right: "16px" }}>
          <Close />
        </IconButton>
      </ModalHeader>
      {/* Bullet points text */}
      <ModalContent style={{ padding: "0px 24px 24px 24px" }}>
        {stakeStage === "info" && (
          <Stack direction={"column"} gap={2}>
            <InfoContentStyle>
              <SmallSpanRoobertMediumDark
                style={{ fontWeight: 600, textDecoration: "underline", textAlign: "left" }}>
                Before you start staking:
              </SmallSpanRoobertMediumDark>

              <SmallSpanRoobertMediumDark style={{ fontWeight: 400, textAlign: "left" }}>
                We set up a secure account that locks your crypto to earn weekly rewards. Getting
                started may take anywhere from a few minutes to several weeks, depending on which
                crypto you choose.
                <br />
                <br />
                Rewards are distributed weekly to all validators on Sunday, 11.59pm UTC. You earn
                staking rewards automatically while your assets remain staked, with no action
                required on your part.
                <br />
                <br />
                Important: Once you start, you cannot cancel or get your money back until the setup
                is complete and your account is active.
              </SmallSpanRoobertMediumDark>
              {/* Button */}
            </InfoContentStyle>

            {/* Button */}
            <StyledButton onClick={() => dispatch(setStakeStage("stake"))}>
              I acknowledge
            </StyledButton>
          </Stack>
        )}
        {stakeStage === "stake" && (
          <div style={{ width: "100%" }}>
            <Formik initialValues={{ coin: "Ethereum" }} onSubmit={() => {}}>
              <Form>
                <Stack gap={2}>
                  {/* Coin Field */}
                  <div>
                    <StyledSelectbuyorsellspan>Coin</StyledSelectbuyorsellspan>
                    <Field name="coin" as={StyledTextField} select placeholder="Select coin">
                      {mockCoins.map((item, it) => (
                        <MenuItem
                          key={item.label + it}
                          value={item.label}
                          sx={{
                            textTransform: "capitalize",
                          }}>
                          <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <span style={{ display: "flex" }}>{item.icon}</span>
                            <Typography>{item.label}</Typography>
                          </Stack>
                        </MenuItem>
                      ))}
                    </Field>
                  </div>
                  {/* APY Field */}
                  <div>
                    <StyledSelectbuyorsellspan>APY</StyledSelectbuyorsellspan>
                    <Field name="apy" value={"2-3%"} as={StyledTextField} disabled={true} />
                  </div>
                  {/* Amount to stake Field */}
                  <div>
                    <StyledSelectbuyorsellspan>Amount to stake</StyledSelectbuyorsellspan>
                    <Field
                      name="amountToStake"
                      as={StyledTextField}
                      type="number"
                      placeholder="Enter amount"
                      InputProps={{
                        endAdornment: (
                          <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <EndAdormentStyledLabel>32 ETH</EndAdormentStyledLabel>
                            <FieldMinStakeButton>Min</FieldMinStakeButton>
                          </Stack>
                        ),
                      }}
                    />
                    {/* Info */}
                    <StyledSelectbuyorsellspan>
                      The minimum stake is xx ETH
                    </StyledSelectbuyorsellspan>
                  </div>
                  {/* Stake button */}
                  <div>
                    <StyledButton onClick={() => dispatch(setStakeStage("review"))}>
                      Stake
                    </StyledButton>
                  </div>
                </Stack>
              </Form>
            </Formik>
          </div>
        )}

        {/* Review stage */}
        {stakeStage === "review" && (
          <Stack direction={"column"} gap={2} width={"100%"} textAlign={"left"}>
            {/* Coin label */}
            <Stack direction={"column"} gap={1}>
              <StyledSelectbuyorsellspan>Coin</StyledSelectbuyorsellspan>
              <StyledStakedspan style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <EthereumPlaceholderLogo />
                Ethereum
              </StyledStakedspan>
            </Stack>

            {/* APY label */}
            <Stack direction={"column"} gap={1}>
              <StyledSelectbuyorsellspan>APY</StyledSelectbuyorsellspan>
              <StyledStakedspan>2-3%</StyledStakedspan>
            </Stack>
            {/* Amount to stake label */}
            <Stack direction={"column"} gap={1}>
              <StyledSelectbuyorsellspan>Amount to stake</StyledSelectbuyorsellspan>
              <StyledStakedspan>32 ETH</StyledStakedspan>
            </Stack>
            {/* Stake button */}
            {/* On review confirm clicked start 2FA authentication process */}
            <StyledButton onClick={() => dispatch(setTwoFAModalOpen(true))}>Confirm</StyledButton>
          </Stack>
        )}

        {stakeStage === "submitted" && (
          <Stack direction={"column"} gap={2} width={"100%"} textAlign={"left"}>
            <InfoContentStyle style={{ background: "#F0FEF9" }}>
              <Stack direction={"row"} gap={1} alignItems={"center"}>
                <GridCheckCircleIcon sx={{ fontSize: "16px", color: "#002035" }} />
                <SmallSpanRoobertMediumDark style={{ fontWeight: 600 }}>
                  Request to stake submitted
                </SmallSpanRoobertMediumDark>
              </Stack>
              <SmallSpanRoobertMediumDark style={{ fontWeight: 400 }}>
                Your staking request has been submitted successfully. You will receive a
                confirmation email shortly. You may track this in your staking page under “history”.
              </SmallSpanRoobertMediumDark>
            </InfoContentStyle>
            <StyledButton onClick={() => dispatch(setStakeStage("info"))}>
              Stake another asset
            </StyledButton>
          </Stack>
        )}
      </ModalContent>
    </ModalWrapper>
  );
};
